import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UIFilterDto, GuidStrValue, ViewOptionDto, ViewOptionResponse } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class UIFilterRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) {
  }

  getFilter<T>(
    filterUid: GuidStrValue
  ): Observable<UIFilterDto<T>> {
    const endpointUrl = `filter/${filterUid}/data`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getDefaultFilter<T>(filterTypeId: GuidStrValue, subType: string): Observable<UIFilterDto<T>> {
    const endpointUrl = `filter/${filterTypeId}/default` + (!!subType ? `?subtype=${subType}` : '');
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  saveFilter<T>(
    filterUid: GuidStrValue,
    data: UIFilterDto<T>,
  ): Observable<UIFilterDto<T>> {
    const endpointUrl = `filter/${filterUid}/data`;
    return this.httpClientService.sendPostRequest(endpointUrl, data);
  }


  getUserOptionsFilter(): Observable<ViewOptionDto> {
    const endpointUrl = `rpn-view-options/user-option`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  updateUserOptionsFilter(viewOptionId: string): Observable<ViewOptionResponse> {
      const endpointUrl = `rpn-view-options/user-option/${viewOptionId}`;
      return this.httpClientService.sendPutRequest(endpointUrl , viewOptionId);
  }

  getSelectedOptionsFilterConfig(viewOptionId: string) {
    const endpointUrl = `rpn-view-options/${viewOptionId}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  updateSelectedOptionsFilterConfig( data: ViewOptionDto): Observable<ViewOptionResponse>{
    const endpointUrl = `rpn-view-options/update`;
    return this.httpClientService.sendPutRequest(endpointUrl, data);
  }

  addSelectedOptionsFilterConfig(data: ViewOptionDto): Observable<ViewOptionResponse> {
    const endpointUrl = `rpn-view-options/create`;
    return this.httpClientService.sendPostRequest(endpointUrl, data);
  }


}
